import NoLicenseDataPlaceholder from '@/../img/placeholders/no-license-data';
import * as lc from '@/license/components/license-content-styles';

export function LicensePlaceholder() {
  return (
    <lc.LicensePlaceholderWrapper>
      <NoLicenseDataPlaceholder alt="No licenses associated with this property" />
      <lc.PlaceholderMainText>No record found.</lc.PlaceholderMainText>

      <lc.PlaceholderSubText>
        There are no licenses associated with this property.
      </lc.PlaceholderSubText>
    </lc.LicensePlaceholderWrapper>
  );
}
